module.exports = __webpack_public_path__ + "img/push.d25daf53.svg";